module.exports = __webpack_public_path__ + "media/images/countrysquared/fk-66295e6e63ee00a5e499db40532935cd.svg";